"use client";

import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

type CopilotCtx = {
  projectId: number | null;
  phaseId: number | null;
  setContext: (v: { projectId?: number | null; phaseId?: number | null }) => void;
};

const Ctx = createContext<CopilotCtx | null>(null);

export function CopilotContextProvider({ children }: { children: React.ReactNode }) {
  const [projectId, setProjectId] = useState<number | null>(null);
  const [phaseId, setPhaseId] = useState<number | null>(null);

  const setContext = useCallback((v: { projectId?: number | null; phaseId?: number | null }) => {
    if (v.projectId !== undefined) setProjectId(v.projectId);
    if (v.phaseId !== undefined) setPhaseId(v.phaseId);
  }, []);

  const value = useMemo(() => ({ projectId, phaseId, setContext }), [projectId, phaseId, setContext]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCopilotContext() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useCopilotContext must be used within CopilotContextProvider");
  return ctx;
}
